import React from "react";
import "../../css/events.css";
import Heading from "../../components/Heading";
import Link from "gatsby-link";
import ContentPage from "../../components/content-page";
import Meta from "../../components/meta";
import PropTypes from "prop-types";
import ReactPixel from "react-facebook-pixel";

import AddToCalendar from "react-add-to-calendar";
import { gelleryImages } from "../../constant/gelleryImages";
import {
  allImages,
  winpeEventImages,
  winImages1,
  winImages2,
  winImages3,
  breakingintoinvestingImages,
  igniteAMAImages,
} from "../../constant/allGelleryImages";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import MediaQuery from "react-responsive";
import "react-tabs/style/react-tabs.css";
import Slider from "react-slick";
import "../../components/slick.css";
import "../../components/slick-theme.css";
const icon1 = "https://winpeforum.com/assets/elements/hero_slider_1.jpg";
const icon2 = "https://winpeforum.com/assets/elements/hero_slider.jpg";
const icon3 =
  "https://winpeforum.com/assets/elements/Winpe_Shine_banner_10_sep.jpg";
const icon4 = "https://winpeforum.com/assets/elements/hero_slider_3.jpg";
const icon5 =
  "https://winpeforum.com/assets/elements/Winpe_Ignite_banner_5_sep.jpg";
const icon6 =
  "https://winpeforum.com/assets/elements/WinPE_Ignite_event_page_hero_omage.jpg";
const icon7 =
  "https://winpeforum.com/assets/elements/WLSTheme2.png  ";
  const icon8 =
  "https://winpeforum.com/assets/elements/winpe-ally-banner.jpg";
const iconp1 = "https://winpeforum.com/assets/elements/phone_slider_1.jpg";
const iconp2 = "https://winpeforum.com/assets/elements/phone_slider_2.jpg";
const iconp3 = "https://winpeforum.com/assets/elements/phone_slider_3.jpg";
const iconp4 = "https://winpeforum.com/assets/elements/phone_slider_4.jpg";
const iconp5 =
  "https://winpeforum.com/assets/elements/Winpe_Ignite_banner_5_sep_phone.jpg";
const iconp6 =
  "https://winpeforum.com/assets/elements/WinPE_Ignite_event_page_hero_omage_phone.jpg";
const iconp7 =
  "https://winpeforum.com/assets/elements/WLSTheme.png";
  const iconp8 =
  "https://winpeforum.com/assets/elements/winpe-ally-phone.jpg";
const icon13 =
  "https://winpeforum.com/api/src/templates/emailers/assets/newsletter2022.png";
let duration = 400;

export class ConnectView extends React.Component {
  constructor(args) {
    super(args);
    this.state = {
      slidesToShow: 1,
      defaultStyle: {
        transition: `opacity ${duration}ms ease-in-out`,
        opacity: 0,
      },
    };
    this.TabContent = [
      {
        tabName: "All",
      },
      {
        tabName: "Winpe Launch Event",
      },
      {
        tabName: "Winpe Ignite Network - Feb' 20",
      },
      {
        tabName: "Winpe Ignite Investors Social",
      },
      {
        tabName: "Winpe ProClub Launch",
      },
      {
        tabName: "Winpe Ignite Breaking Into Investing",
      },
      {
        tabName: "Winpe Ignite Ask Me Anything",
      },
    ];
    this.heroslider = [
      
      {
        imgUrl: icon7,
        pageUrl: "https://winpeleadershipsummit.winpeforum.com/",
      },
      
    ];

    this.phoneheroslider = [
      {
        imgUr: iconp6,
        pageUrl: "#",
      },

      {
        imgUr: iconp1,
        pageUrl: "https://proclub.winpeforum.com/",
      },
      {
        imgUr: iconp3,
        pageUrl: "#",
      },
      {
        imgUr: iconp2,
        pageUrl: "#",
      },
      {
        imgUr: iconp8,
        pageUrl: "#",
      },
      {
        imgUr: iconp7,
        pageUrl: "https://winpeleadershipsummit.winpeforum.com/",
      },
    ];
  }
  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    ReactPixel.init("2879175222167037");
    ReactPixel.track("ViewContent", location);
    setTimeout(() => {
      this.setState({
        defaultStyle: {
          transition: `opacity ${duration}ms ease-in-out`,
          opacity: 1,
        },
      });
    }, 500);
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    const { slidesToShow } = this.state;
    if (window.innerWidth <= 768 && window.innerWidth > 500) {
      if (slidesToShow !== 2) {
        this.setState({
          slidesToShow: 2,
        });
      }
    } else if (window.innerWidth <= 500) {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    } else {
      if (slidesToShow !== 3) {
        this.setState({
          slidesToShow: 3,
        });
      }
    }
  };
  render() {
    const { defaultStyle, slidesToShow } = this.state;
    const { location } = this.props;
    let icon = { textOnly: "none" };
    let items = [
      { outlook: "Outlook" },
      { apple: "iCal" },
      { yahoo: "Yahoo!" },
      { google: "Google" },
    ];
    let settings = {
      dots: false,
      infinite: true,
      speed: 6000,
      autoplay: true,
      slidesToShow: slidesToShow,
      slidesToScroll: slidesToShow,
      autoplaySpeed: 7000,
      arrows: true,
    };
    let settingsing = {
      dots: false,
      infinite: true,
      speed: 6000,
      autoplay: true,
      slidesToShow: 2,
      slidesToScroll: slidesToShow,
      autoplaySpeed: 7000,
      arrows: true,
    };
    let settingsingRes = {
      dots: false,
      infinite: true,
      speed: 6000,
      autoplay: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplaySpeed: 7000,
      arrows: true,
    };
    let settings5 = {
      dots: true,
      infinite: true,
      speed: 200,
      autoplay: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplaySpeed: 3000,
      arrows: true,
    };
    this.render1 = this.render1 + 1;
    return (
      <ContentPage>
        <Meta
          title="Winpe | Diversity is Now | Upcoming Events"
          image={icon13}
          description="View Winpe’s calendar of events including Winpe flagship initiatives that span multiple formats to enable dialogue, networking and knowledge sharing in the private equity industry."
          location={location}
        />
        <div className="section__content" style={defaultStyle}>
          <div className="events_wrapper">
            <div className="events_section">
              <div className="events_content">
                {/*
								<div className="event_content_text">
									<img src="https://winpeforum.com/assets/elements/WinPE_4b.jpg" alt="" className="img-responsive" />
								</div>
							*/}
              </div>
             {/* <div>
               <a href="https://winpeleadershipsummit.winpeforum.com/" target="_blank">  
               <img src="https://winpeforum.com/assets/elements/WLSThemenew4.png" style={{width: '100%'}}/>
               </a>
              {/* <MediaQuery query="(min-width: 768px)">
                  <div className="hero_slider" style={{height: '500px'}}>
                    <Slider {...settings5}>
                      {this.heroslider.map((item, j) => {
                        return (
                          <div className="gellery_card" key={j}>
                            <a href={item.pageUrl} target="_blank">
                              <img src={item.imgUrl} alt="event_hero" />
                            </a>
                          </div>
                        );
                      })}
                    </Slider>
                  </div>
                </MediaQuery>
                <MediaQuery query="(max-width: 767px)">
                  <div className="hero_slider">
                    <Slider {...settings5}>
                      {this.phoneheroslider.map((item, k) => {
                        return (
                          <div className="gellery_card" key={k}>
                            <a href={item.pageUrl} target="_blank">
                              <img src={item.imgUr} alt="event_hero" />
                            </a>
                          </div>
                        );
                      })}
                    </Slider>
                  </div>
                </MediaQuery> 
              </div>*/}
              <div className="event_mid_section">
                <div className="event_mid_content">
                  <div className="event_mid_heading">
                    <div className="">
                      <Heading title="Winpe Event Calendar" />
                    </div>
                  </div>
                  <br/>
                   <a href="/event-calendar/"><button style={{marginLeft:'16%', widht:'100%', backgroundColor:"#BF2026", border:"none", color:"#fff", padding:"5px 20px 5px 20px", fontSize:"20px", marginBottom: "10px"}} class="button"><i class="fa fa-calendar"></i> &nbsp; &nbsp;View Yearly Event Planner</button>  </a>  
                  <div className="eventlist_listing eventlist_listing_new">
<div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                      <div className="top_e_border"></div>
                        <div className="list_card">
                          <div className="list_date">31 MARCH 2026</div>
                          <div className="list_t1">
                            <strong>
                            Winpe Leadership Summit & Awards 2025
                            </strong>
                          </div>
                          <div className="list_t2">Taj Lands End, Mumbai</div>
                          <div className="list_t3">
                            <div className="list_t3_box1">
                              <a
                                
                                href="https://winpeleadershipsummit.winpeforum.com/"
                              >
                        View Details
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    
    <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                        
                        <div className="list_card">
                          <div className="list_date">4 DECEMBER 2025</div>
                          <div className="list_t1">
                            <strong>
                           Board Excellence Training
                            </strong>
                          </div>
                          <div className="list_t2"> Taj Lands End, Mumbai
                          </div>
                          <div className="list_t3">
                             <div className="list_t3_box2">
                              <a href="/wob-training-module2/">
                              View Details
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
   
    <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                           
                        <div className="list_card">
                          <div className="list_date">15 NOVEMBER 2025</div>
                          <div className="list_t1">
                            <strong>
                           Winpe Ignite Career Talk Session
                            </strong>
                          </div>
                          <div className="list_t2"> ONLINE
                          </div>
                          <div className="list_t3">
                             <div className="list_t3_box1">
                              <a href="https://forms.gle/D6SwGTeLRpsFmuo89">
                              Register Now
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
  <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                 
                        <div className="list_card">
                          <div className="list_date">6 NOVEMBER 2025</div>
                          <div className="list_t1">
                            <strong>
                            sheshines with Winpe: Networking event
                            </strong>
                          </div>
                          <div className="list_t2"> A91 Partners Office, Mumbai
                          </div>
                          <div className="list_t3">
                             <div className="list_t3_box2">
                              <a href="/SheShines/">
                             View Details
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
  <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                  
                     
                        <div className="list_card">
                          <div className="list_date">24 SEPTEMBER 2025</div>
                          <div className="list_t1">
                            <strong>
                            sheshines with Winpe: Networking event
                            </strong>
                          </div>
                          <div className="list_t2">Google office, Gurgaon

                          </div>
                          <div className="list_t3">
                            <div className="list_t3_box1">
                              <a href="/sheshines24Sep2025/">
                              Event Report
                              </a>  
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    

  <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                        <div className="list_card">
                          <div className="list_date">11 SEPTEMBER 2025</div>
                          <div className="list_t1">
                            <strong>
                           Board Excellence Training
                            </strong>
                          </div>
                          <div className="list_t2"> Taj Lands End, Mumbai
                          </div>
                          <div className="list_t3">
                             <div className="list_t3_box2">
                              <a href="https://winpeforum.com/WOBModule1EventReport/">
                              Event Report
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
   <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                      
                        <div className="list_card">
                          <div className="list_date">4 AUGUST 2025</div>
                          <div className="list_t1">
                          <strong> Mentee Applications Closed <br/>Winpe ProClub Mentorship Program</strong>
                          </div>
                          <div className="list_t2">Online</div>
                          <div className="list_t3">
                            <div className="list_t3_box1">
                              <a href="https://proclub.winpeforum.com/cohortVI">
                    View Details
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                 <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                     
                        <div className="list_card">
                          <div className="list_date">
                          
                          </div>
                          <div className="list_t1">
                            <strong> Winpe Ignite Career Talk Series</strong>
                          </div>
                          <div className="list_t2"></div>
                          <div className="list_t3">
                          
                          </div>
                        
                          <div className="list_date">
                          19 JULY 2025
                          </div>
                          <div className="list_t1">
                            <strong>
                            Decoding Culture Fit</strong>
                          </div>
                          <div className="list_t2">ONLINE</div>
                          <div className="list_t3">
                               <div className="list_t3_box2">   <a href="/DecodingCultureFit/">
                          Event Report</a>
                            </div>
                          </div>
                         
                          <div className="list_date">
                          26 JULY 2025
                          </div>
                          <div className="list_t1">
                            <strong>Crafting Impactful Resumes: Stand Out in 6 Seconds or Less

</strong>
                          </div>
                          <div className="list_t2">ONLINE</div>
                          <div className="list_t3">
                            <div className="list_t3_box1">   <a href="/CraftingImpactfulResumes/">
                          Event Report</a>
                            </div>
                          </div>
                        
                          <div className="list_date">
                           02 AUGUST 2025 
                          </div>
                          <div className="list_t1">
                            <strong>
                            Mastering the Interview: From Preparation to Presence</strong>
                          </div>
                          <div className="list_t2">ONLINE</div>
                          <div className="list_t3">
                             <div className="list_t3_box2">   <a href="/MasteringTheInterview/">
                          Event Report</a>
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                  <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                  
                        <div className="list_card">
                          <div className="list_date">19 JUNE 2025</div>
                          <div className="list_t1">
                            <strong>
                            sheshines with Winpe: Networking event
                            </strong>
                          </div>
                          <div className="list_t2">Bangalore

                          </div>
                          <div className="list_t3">
                            <div className="list_t3_box1">
                              <a href="/sheshines19June2025/">
                                Event Report
                              </a>  
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                  <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                  
                        <div className="list_card">
                          <div className="list_date">17 MAY 2025 </div>
                          <div className="list_t1">
                            <strong>
                            PEVC Career Talk Series | Session 02<br/>
                            Understanding PEVC Culture: Career Progression and Promotion Paths
                            </strong>
                          </div>
                          <div className="list_t2">ONLINE
                          </div>
                          <div className="list_t3">
                             <div className="list_t3_box2">
                              <a href="/PEVC-Career-Talk-Session2/">
          Event Report
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                  
                        <div className="list_card">
                          <div className="list_date">20 MARCH 2025</div>
                          <div className="list_t1">
                            <strong>
                            Winpe Leadership Summit & Awards 2025
                            </strong>
                          </div>
                          <div className="list_t2">Taj Lands End, Mumbai</div>
                          <div className="list_t3">
                            <div className="list_t3_box1">
                              <a
                                
                                href="https://winpeleadershipsummit.winpeforum.com/event-report-2025/"
                              >
                        Event Report
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                 
                    <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                        
                        <div className="list_card">
                          <div className="list_date">
                          FEBRUARY 2025
                          </div>
                          <div className="list_t1">
                            <strong> Winpe Ignite Masterclass | Series 01  
                           
</strong>
                          </div>
                          <div className="list_t2">ONLINE</div>
                          <div className="list_t3">
                            <div className="list_t3_box2">   <a href="/WinpeIgniteMasterclassSeries01/">
                           Event Report</a>
                            </div>
                          </div>
                        
                          <div className="list_date">
                          13 FEBRUARY 2025
                          </div>
                          <div className="list_t1">
                            <strong> <span  style={{color:'#22316b'}}>Session 01</span><br/> 
                            Term Sheets: A Practical Guide to Negotiating Deals</strong>
                          </div>
                          <div className="list_t2">ONLINE</div>
                          <div className="list_t3">
                             
                          </div>
                         
                          <div className="list_date">
                          20 FEBRUARY 2025
                          </div>
                          <div className="list_t1">
                            <strong> <span style={{color:'#22316b'}}>Session 02</span>
<br/>Governance: Navigating complexities at PEVC backed companies
Online
</strong>
                          </div>
                          <div className="list_t2">ONLINE</div>
                          <div className="list_t3">
                            
                          </div>
                        
                          <div className="list_date">
                           28 FEBRUARY 2025 
                          </div>
                          <div className="list_t1">
                            <strong><span  style={{color:'#22316b'}}>Session 03</span><br/>
                            Structuring Deals: Investment Instruments for PEVC
Online</strong>
                          </div>
                          <div className="list_t2">ONLINE</div>
                          <div className="list_t3">
                          
                          </div>
                        </div>

                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                     
                        <div className="list_card">
                          <div className="list_date">6 FEBRUARY 2025</div>
                          <div className="list_t1">
                            <strong>
                            sheshines with Winpe: Networking event
                            </strong>
                          </div>
                          <div className="list_t2">Jaypee Vasant Continental,<br/>Vasant Vihar, New Delhi

                          </div>
                          <div className="list_t3">
                            <div className="list_t3_box1">
                              <a href="/sheshines6Feb2025/">
          Event Report
                              </a>  
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                  <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                    
                        <div className="list_card">
                          <div className="list_date">14 DECEMBER 2024</div>
                          <div className="list_t1">
                            <strong>
                            PEVC Career Talk Series | Session 01<br/>
Navigating the Path to PEVC: Preparation and Experiences in the Industry

                            </strong>
                          </div>
                          <div className="list_t2">Online
                          </div>
                          <div className="list_t3">
                            <div className="list_t3_box2">
                              <a href="/PEVC-Career-Talk-Session1/">
          Event Report
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                     
                        <div className="list_card">
                          <div className="list_date">28 NOVEMBER 2024</div>
                          <div className="list_t1">
                            <strong>
                            sheshines with Winpe: Networking event
                            </strong>
                          </div>
                          <div className="list_t2">Wink, Vivanta, Bengaluru
                          </div>
                          <div className="list_t3">
                            <div className="list_t3_box1">
                              <a href="/Sheshines28Nov2024/">
             Event Report
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                     
                        <div className="list_card">
                          <div className="list_date">17 OCTOBER 2024</div>
                          <div className="list_t1">
                            <strong>
                            sheshines with Winpe: Networking event
                            </strong>
                          </div>
                          <div className="list_t2">Motilal Oswal Tower, Prabhadevi, Mumbai
                          </div>
                          <div className="list_t3">
                            <div className="list_t3_box2">
                              <a href="/SheShines17Oct2024/">
              Event Report
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                    
                        <div className="list_card">
                          <div className="list_date">7 AUGUST 2024</div>
                          <div className="list_t1">
                            <strong>
                            sheshines with Winpe: Networking event
                            </strong>
                          </div>
                          <div className="list_t2">Delhi NCR</div>
                          <div className="list_t3">
                            <div className="list_t3_box1">
                              <a href="/SheShines7Aug2024/">
                Event Report
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                      
                        <div className="list_card">
                          <div className="list_date">15 JULY 2024</div>
                          <div className="list_t1">
                          <strong> Mentee Applications Closed <br/>Winpe ProClub Mentorship Program</strong>
                          </div>
                          <div className="list_t2">Online</div>
                          <div className="list_t3">
                            <div className="list_t3_box2">
                              <a href="https://proclub.winpeforum.com/cohortV">
                    View Details
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                      
                        <div className="list_card">
                          <div className="list_date">23 MAY 2024</div>
                          <div className="list_t1">
                            <strong>
                            sheshines with Winpe: Networking event
                            </strong>
                          </div>
                          <div className="list_t2">Bangalore International Centre</div>
                          <div className="list_t3">
                            <div className="list_t3_box1">
                              <a href="/SheShines23May2024/">
                     Event Report
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                 
                  <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                     
                        <div className="list_card">
                          <div className="list_date">22 MARCH 2024</div>
                          <div className="list_t1">
                            <strong>
                            Winpe Leadership Summit & Awards 2024
                            </strong>
                          </div>
                          <div className="list_t2">Taj Lands End, Mumbai</div>
                          <div className="list_t3">
                            <div className="list_t3_box2">
                              <a
                                
                                href="https://winpeleadershipsummit.winpeforum.com/event-report-2024/"
                              >
                          Event Report
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                      
                        <div className="list_card">
                          <div className="list_date">24 JANUARY 2024</div>
                          <div className="list_t1">
                            <strong>
                            sheshines with Winpe: Networking event
                            </strong>
                          </div>
                          <div className="list_t2">Delhi NCR</div>
                          <div className="list_t3">
                            <div className="list_t3_box1">
                              <a
                                
                                href="/SheShines24Jan2024/"
                              >
                           Event Report
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                 
                  <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                     
                        <div className="list_card">
                          <div className="list_date">13 OCTOBER 2023</div>
                          <div className="list_t1">
                            <strong>
                            sheshines with Winpe: Networking event
                            </strong>
                          </div>
                          <div className="list_t2">Mumbai</div>
                          <div className="list_t3">
                            <div className="list_t3_box2">
                              <a
                                
                                href="/SheShines/"
                              >
                            Event Report
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                 
                  <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                    
                        <div className="list_card">
                          <div className="list_date">22 SEPTEMBER 2023</div>
                          <div className="list_t1">
                            <strong>
                            Ask Me Anything with Ashley Menezes
                            </strong>
                          </div>
                          <div className="list_t2">Delhi NCR</div>
                          <div className="list_t3">
                          <div className="list_t3_box1">
                              <a
                                
                                href="/AskMeAnything/"
                              >
                          Event Report
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                     
                
                     
                    
                  <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                 
                        <div className="list_card">
                          <div className="list_date">24 AUGUST 2023</div>
                          <div className="list_t1">
                            <strong>
                            sheshines with Winpe: Networking event
                            </strong>
                          </div>
                          <div className="list_t2">Bangalore</div>
                          <div className="list_t3">
                            <div className="list_t3_box2">
                              <a
                                
                                href="/SheShines/"
                              >
                           Event Report
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                     
                    
                  
                    
                    <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                     
                        <div className="list_card">
                          <div className="list_date">27 JULY 2023</div>
                          <div className="list_t1">
                            <strong>
                            sheshines with Winpe: Networking event
                            </strong>
                          </div>
                          <div className="list_t2">Delhi NCR</div>
                          <div className="list_t3">
                            <div className="list_t3_box1">
                              <a
                                
                                href="/sheshines27July2023/"
                              >
                               Event Report
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                 
                   
                    <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                      
                        <div className="list_card">
                          <div className="list_date">8 July 2023</div>
                          <div className="list_t1">
                            <strong>
                            Winpe Ignite | Career Fair 2023
                            </strong>
                          </div>
                          <div className="list_t2">Online</div>
                          <div className="list_t3">
                            <div className="list_t3_box2">
                              <a
                                
                                href="/Career-Initiatives23/"
                              >
                              Event Report
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                   
                    <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                    
                        <div className="list_card">
                          <div className="list_date">1 July 2023</div>
                          <div className="list_t1">
                            <strong>
                            Winpe Ignite | Career Bootcamp  

                            </strong>
                          </div>
                          <div className="list_t2">Online</div>
                          <div className="list_t3">
                            <div className="list_t3_box1">
                              <a
                                
                                href="/Career-Initiatives23/"
                              >
                           Event Report
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                     
                        <div className="list_card">
                          <div className="list_date">28 APRIL 2023</div>
                          <div className="list_t1">
                            <strong>
                            Winpe Leadership Summit & Awards 2023
                            </strong>
                          </div>
                          <div className="list_t2">Four Seasons, Mumbai</div>
                          <div className="list_t3">
                            <div className="list_t3_box2">
                              <a
                                 target="__blank"
                                href="https://winpeleadershipsummit.winpeforum.com/event-report/"
                              >
                              Event Report
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                 
                 <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                      
                        <div className="list_card">
                          <div className="list_date">19 JANUARY 2023</div>
                          <div className="list_t1">
                            <strong>
                            sheshines with Winpe: Networking event
                            </strong>
                          </div>
                          <div className="list_t2">Jook Taproom, Indiranagar, Bangalore</div>
                          <div className="list_t3">
                            <div className="list_t3_box1">
                              <a
                                // target="__blank"
                                href="/SheShines19Jan2023/"
                              >
                              Event Report
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                 
                  <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                     
                        <div className="list_card">
                          <div className="list_date">10 NOVEMBER 2022</div>
                          <div className="list_t1">
                            <strong>
                            sheshines with Winpe: Networking event
                            </strong>
                          </div>
                          <div className="list_t2">The Quorum Club, LowerParel, Mumbai</div>
                          <div className="list_t3">
                            <div className="list_t3_box2">
                              <a
                                // target="__blank"
                                href="/SheShines10Nov2022/"
                              >
                               Event Report
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                     
                        <div className="list_card">
                          <div className="list_date">25 AUGUST 2022</div>
                          <div className="list_t1">
                            <strong>
                            sheshines with Winpe: Networking event
                            </strong>
                          </div>
                          <div className="list_t2">Hotel Andaz, Aerocity - Delhi</div>
                          <div className="list_t3">
                            <div className="list_t3_box1">
                              <a
                                // target="__blank"
                                href="/SheShines25Aug2022/"
                              >
                              Event Report
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                   
                        <div className="list_card">
                          <div className="list_date">30 JUNE 2022</div>
                          <div className="list_t1">
                            <strong>
                            sheshines with Winpe: Networking event
                            </strong>
                          </div>
                          <div className="list_t2">Kazé, Bangalore</div>
                          <div className="list_t3">
                            <div className="list_t3_box2">
                              <a
                                // target="__blank"
                                href="/SheShines30June2022/"
                              >
                              Event Report
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                     
                        <div className="list_card">
                          <div className="list_date">18 JUNE 2022</div>
                          <div className="list_t1">
                            <strong>
                            Winpe Career Day
                            </strong>
                          </div>
                          <div className="list_t2">ONLINE</div>
                          <div className="list_t3">
                            <div className="list_t3_box1">
                              <a  href="/CareerDay/" >
                              Event Report
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                   
                    <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                      
                        <div className="list_card">
                          <div className="list_date">15 JUNE 2022</div>
                          <div className="list_t1">
                            <strong>
                            ProClub Mentorship Program Cohort III Applications Closed
                            </strong>
                          </div>
                          <div className="list_t2">ONLINE</div>
                          <div className="list_t3">
                            <div className="list_t3_box2">
                              <a
                                // target="__blank"
                                href="https://proclub.winpeforum.com/cohortIII"
                              >
                                View Details
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                       
                        <div className="list_card">
                          <div className="list_date">21 APRIL 2022</div>
                          <div className="list_t1">
                            <strong>
                            sheshines with Winpe: Networking event
                            </strong>
                          </div>
                          <div className="list_t2">The Quorum Club, LowerParel, Mumbai</div>
                          <div className="list_t3">
                            <div className="list_t3_box1">
                              <a
                                // target="__blank"
                                href="/SheShinesWithWinPE/"
                              >
                               Event Report
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                      
                        <div className="list_card">
                          <div className="list_date">8 MARCH 2022</div>
                          <div className="list_t1">
                            <strong>
                            What are the funds doing to increase diversity within and their portfolio companies
                              <br />@ IVCA Conclave 2022
                            </strong>
                          </div>
                          <div className="list_t2">ONLINE</div>
                          <div className="list_t3">
                            <div className="list_t3_box2">
                              <a
                                // target="__blank"
                                href="/ivcaconclave2022/"
                              >
                                Event Report
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                     
                        <div className="list_card">
                          <div className="list_date">
                           DECEMBER 2021 - MARCH 2022
                          </div>
                          <div className="list_t1">
                            <strong> Winpe Alicorn Leadership Summit 2021-22</strong>
                          </div>
                          <div className="list_t2">ONLINE</div>
                          <div className="list_t3">
                          <div className="list_t3_box1">
                              <a  target="_BLANK" href="https://winpeleadershipsummit.winpeforum.com/home/">View Details</a>
                            </div>
                          </div>
                        
                          <div className="list_date">
                          16 DECEMBER 2021 
                          </div>
                          <div className="list_t1">
                            <strong>Session 1: Leaders Today, Icons Tomorrow</strong>
                          </div>
                          <div className="list_t2">ONLINE</div>
                          <div className="list_t3">
                         
                          </div>
                         
                          <div className="list_date">
                         28 JANUARY 2022
                          </div>
                          <div className="list_t1">
                            <strong>Session 2: Global Perspectives: Diversity in Leadership</strong>
                          </div>
                          <div className="list_t2">ONLINE</div>
                          <div className="list_t3">
                            
                          </div>
                        
                          <div className="list_date">
                          1 MARCH 2022
                          </div>
                          <div className="list_t1">
                          <strong>Session 3: Investing for the Future</strong>
                          </div>
                          <div className="list_t2">ONLINE</div>
                          <div className="list_t3">
                          
                          </div>
                        </div>

                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                      
                        <div className="list_card">
                          <div className="list_date">
                          8 JANUARY 2021
                          </div>
                          <div className="list_t1">
                            <strong>"Wharton India Economic Forum 2022 | Panel discussion on "Bridging the talent gap" </strong>
                          </div>
                          <div className="list_t2">ONLINE</div>
                          <div className="list_t3">
                            <div className="list_t3_box2">
                              <a  target="_BLANK" href="/WhartonIndiaEconomicForum">Event Report</a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                      
                        <div className="list_card">
                          <div className="list_date">
                          3 DECEMBER 2021
                          </div>
                          <div className="list_t1">
                            <strong> The 2nd edition of D2C Summit - Fireside chat on Why India's $100 Bn D2C Economy needs a Sustainable Approach </strong>
                          </div>
                          <div className="list_t2">ONLINE</div>
                          <div className="list_t3">
                            <div className="list_t3_box1">
                              <a  target="_BLANK" href="/D2CSummit">Event Report</a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                      
                        <div className="list_card">
                          <div className="list_date">
                          OCTOBER - DECEMBER 2021
                          </div>
                          <div className="list_t1">
                            <strong>  Industry Disruption 2.0 with UN Women </strong>
                          </div>
                          <div className="list_t2">ONLINE</div>
                          <div className="list_t3">
                            <div className="list_t3_box2">
                              <a  target="_BLANK" href="/Industry-Dirupton-2">View Details</a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                     
                        <div className="list_card">
                          <div className="list_date">
                          ONGOING, FORTNIGHTLY
                          </div>
                          <div className="list_t1">
                            <strong>Winpe Workshop with Women in Investing</strong>
                          </div>
                          <div className="list_t2">ONLINE</div>
                          <div className="list_t3">
                            <div className="list_t3_box1">
                              <a href="/women-in-investing">View Details</a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                      
                        <div className="list_card">
                          <div className="list_date">
                            2 NOVEMBER 2021  
                          </div>
                          <div className="list_t1">
                            <strong> Asia Gender-Smart Investing Forum — “Introduction to Gender Smart Investment Tools and Frameworks” </strong>
                            
                          </div>
                          <div className="list_t2">ONLINE</div>
                          <div className="list_t3">
                            <div className="list_t3_box2">
                              <a  target="_BLANK" href="/Asia-Gender-Smart-Investing-Forum">Event Report</a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                      
                        <div className="list_card">
                          <div className="list_date">
                            30 OCTOBER 2021  
                          </div>
                          <div className="list_t1">
                            <strong> Driving Gender Balance among Enterprise Founders and Investors </strong> 
                          </div>
                          <div className="list_t2">ONLINE</div>
                          <div className="list_t3">
                            <div className="list_t3_box1">
                              <a  target="_BLANK" href="/Driving-Gender-Balance">Event Report</a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                      
                        <div className="list_card">
                          <div className="list_date">
                            22 OCTOBER 2021  
                          </div>
                          <div className="list_t1">
                            <strong> Winpe Ally Network - Pilot | Multi Group Meet </strong>
                          </div>
                          <div className="list_t2">ONLINE</div>
                          <div className="list_t3">
                            <div className="list_t3_box2">
                              <a  target="_BLANK" href="/ally-network">View Details</a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                   
                  <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                     
                        <div className="list_card">
                          <div className="list_date">
                          18 OCTOBER 2021  
                          </div>
                          <div className="list_t1">
                          <strong> Winpe ProClub Mentorship Program: Workshop with Mentors Cohort II</strong> <br /> By Invite Only
                          </div>
                          <div className="list_t2">ONLINE</div>
                          <div className="list_t3">
                            <div className="list_t3_box1">
                            <a href="https://proclub.winpeforum.com/events/">Event Report</a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                      
                        <div className="list_card">
                          <div className="list_date">
                          7 OCTOBER 2021  
                          </div>
                          <div className="list_t1">
                          <strong> Maximum India Conclave #MIC 2021 - Fireside Chat: "Corporate Governance for PEVC in India | The Good and The Better</strong>  
                          </div>
                          <div className="list_t2">ONLINE</div>
                          <div className="list_t3">
                            <div className="list_t3_box2">
                            <a href="/IVCA-MIC2021">Event Report</a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                      
                        <div className="list_card">
                          <div className="list_date">
                          6 OCTOBER 2021  
                          </div>
                          <div className="list_t1">
                          <strong> Winpe ProClub Mentorship Program: Workshop with Mentees Cohort II</strong> <br /> By Invite Only
                          </div>
                          <div className="list_t2">ONLINE</div>
                          <div className="list_t3">
                            <div className="list_t3_box1">
                            <a href="https://proclub.winpeforum.com/events/">Event Report</a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                     
                        <div className="list_card">
                          <div className="list_date">
                          29 SEPTEMBER 2021  
                          </div>
                          <div className="list_t1">
                            <strong> Winpe Collegium</strong>
                          </div>
                          <div className="list_t2">ONLINE</div>
                          <div className="list_t3">
                            <div className="list_t3_box2">
                            <a href="/winpe-collegium-sep-2021">Event Report</a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                     
                        <div className="list_card">
                          <div className="list_date">
                          28 SEPTEMBER 2021  
                          </div>
                          <div className="list_t1">
                            <strong> Winpe ProClub Mentorship Program: Launch Event Cohort II</strong> <br /> By Invite Only
                          </div>
                          <div className="list_t2">ONLINE</div>
                          <div className="list_t3">
                            <div className="list_t3_box1">
                            <a href="https://proclub.winpeforum.com/events/">Event Report</a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                     
                        <div className="list_card">
                          <div className="list_date">
                          25 SEPTEMBER 2021  
                          </div>
                          <div className="list_t1">
                            <strong> Winpe Ignite Career Conversations | A Day as an Investment Analyst</strong>
                          </div>
                          <div className="list_t2">ONLINE</div>
                          <div className="list_t3">
                            <div className="list_t3_box2">
                            <a href="/CareerConversations">Event Report</a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  
                 

                    <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                        
                        <div className="list_card">
                          <div className="list_date">
                           AUGUST 2021 - SEPTEMBER 2021 
                          </div>
                          <div className="list_t1">
                            <strong> Winpe Edge: Masterclass Series with Trilegal</strong>
                          </div>
                          <div className="list_t2">ONLINE</div>
                          <div className="list_t3">
                            <div className="list_t3_box1">
                              <a href="/winpe-edge-masterclass-series-with-trilegal/">Event Report</a>
                            </div>
                          </div>
                        
                          <div className="list_date">
                          7 AUGUST 2021 
                          </div>
                          <div className="list_t1">
                            <strong>Term Sheets</strong>
                          </div>
                          <div className="list_t2">ONLINE</div>
                          <div className="list_t3">
                             
                          </div>
                         
                          <div className="list_date">
                          21 AUGUST 2021 
                          </div>
                          <div className="list_t1">
                            <strong> Due Diligence Including Considerations for Start Ups and ESG</strong>
                          </div>
                          <div className="list_t2">ONLINE</div>
                          <div className="list_t3">
                            
                          </div>
                        
                          <div className="list_date">
                           4 SEPTEMBER 2021 
                          </div>
                          <div className="list_t1">
                            <strong>M&A; Exit Strategies</strong>
                          </div>
                          <div className="list_t2">ONLINE</div>
                          <div className="list_t3">
                          
                          </div>
                        </div>

                      </div>
                    </div>

                 
                  <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                     
                        <div className="list_card">
                          <div className="list_date">
                          2 AUGUST 2021  
                          </div>
                          <div className="list_t1">
                            <strong> Winpe Ally Network: Launch Meeting</strong> <br /> Members Only
                          </div>
                          <div className="list_t2">ONLINE</div>
                          <div className="list_t3">
                            <div className="list_t3_box2">
                              <a   href="/ally-network">View Details</a> 
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                   
                        <div className="list_card">
                          <div className="list_date">
                          26 JUNE 2021 - 26 JULY 2021
                          </div>
                          <div className="list_t1">
                            <strong> Winpe Ally Network - Pilot</strong>
                          </div>
                          <div className="list_t2">ONLINE</div>
                          <div className="list_t3">
                            <div className="list_t3_box1">
                              <a  target="_BLANK" href="/ally-network">View Details</a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                      
                        <div className="list_card">
                          <div className="list_date">
                         22 JULY 2021
                          </div>
                          <div className="list_t1">
                            <strong> Winpe Collegium</strong> <br /> By Invite Only
                          </div>
                          <div className="list_t2">ONLINE</div>
                          <div className="list_t3">
                            <div className="list_t3_box2">
                              <a   href="/winpe-collegium">Event Report</a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                     
                        <div className="list_card">
                          <div className="list_date">10 JULY 2021</div>
                          <div className="list_t1">
                            <strong>Build the Brand U <br/>Winpe Shine Leadership Development Series</strong>
                          </div>
                          <div className="list_t2">ONLINE</div>
                          <div className="list_t3">
                            <div className="list_t3_box1">
                              <a href="/build-brand-u"> Event Report</a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                      
                        <div className="list_card">
                          <div className="list_date">
                         6 JULY 2021
                          </div>
                          <div className="list_t1">
                            <strong> Gender Lens Investing: Experiences So Far and Way Ahead - Panel Discussion @ 2nd IVCA Impact and Sustainable Investment Conference
</strong>
                          </div>
                          <div className="list_t2">ONLINE</div>
                          <div className="list_t3">
                            <div className="list_t3_box2">
                              <a  target="_BLANK" href="/IVCA-Impact-and-Sustainable-Investment-Conference">Event Report</a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                     
                        <div className="list_card">
                          <div className="list_date">2 JULY 2021</div>
                          <div className="list_t1">
                            <strong>Winpe Ignite: Campus Connect at SPJIMR</strong>
                            
                          </div>
                          <div className="list_t2">ONLINE</div>
                          <div className="list_t3">
                            <div className="list_t3_box1">
                              <a href="/ignite-campus-connect"> Event Report</a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                      {/* <div className="top_e_border"></div>   */}
                        <div className="list_card">
                          <div className="list_date">
                          15 JUNE 2021
                          </div>
                          <div className="list_t1">
                            <strong> Mentee Applications Closed <br/>Winpe ProClub Mentorship Program</strong>
                          </div>
                          <div className="list_t2">ONLINE</div>
                          <div className="list_t3">
                            <div className="list_t3_box2">
                              <a  target="_BLANK" href="https://proclub.winpeforum.com/cohortII">See Details</a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                        
                        <div className="list_card">
                          <div className="list_date">
                           MAY 2021 - JUNE 2021 
                          </div>
                          <div className="list_t1">
                            <strong>Winpe Ignite Career Bootcamp</strong>
                          </div>
                          <div className="list_t2">ONLINE</div>
                          <div className="list_t3">
                            <div className="list_t3_box1">
                              <a href="/careerbootcamp/">Event Report</a>
                            </div>
                          </div>
                        
                          <div className="list_date">
                          29 MAY 2021 
                          </div>
                          <div className="list_t1">
                            <strong>Panel Discussion with Recent Hires on Getting that Investing Job</strong>
                          </div>
                          <div className="list_t2">ONLINE</div>
                          <div className="list_t3">
                             
                          </div>
                         
                          <div className="list_date">
                          5 JUNE 2021 
                          </div>
                          <div className="list_t1">
                            <strong> Recruiters' Insights on How to Make a Good CV</strong>
                          </div>
                          <div className="list_t2">ONLINE</div>
                          <div className="list_t3">
                            
                          </div>
                        
                          <div className="list_date">
                           12 JUNE 2021 
                          </div>
                          <div className="list_t1">
                            <strong>Mock Interview Panel</strong>
                          </div>
                          <div className="list_t2">ONLINE</div>
                          <div className="list_t3">
                          
                          </div>
                        </div>

                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                        
                        <div className="list_card">
                          <div className="list_date">
                          21 MAY 2021
                          </div>
                          <div className="list_t1">
                            <strong> ProClub Dialogues (By Invite Only)</strong>
                          </div>
                          <div className="list_t2">ONLINE</div>
                          <div className="list_t3">
                            <div className="list_t3_box2">
                              <a  target="_BLANK" href="https://proclub.winpeforum.com/events/">Event Report</a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                        <div className="list_card">
                          <div className="list_date">22 APRIL 2021</div>
                          <div className="list_t1">
                            <strong>Winpe Collegium</strong>
                            <br /> By Invite Only
                          </div>
                          <div className="list_t2">ONLINE</div>
                          <div className="list_t3">
                            <div className="list_t3_box1">
                              <a href="/firstcollegium2021">Event Report</a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                        <div className="list_card">
                          <div className="list_date">20 MARCH 2021</div>
                          <div className="list_t1">
                            <strong>
                            Winpe Ignite <br />
                              Ask Me Anything
                            </strong>
                            <br />
                          </div>
                          <div className="list_t2">ONLINE</div>
                          <div className="list_t3">
                            <div className="list_t3_box2">
                              <a href="/ignite-askmeanything/">Event Report</a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                        {/* <div className="top_e_border"></div> */}
                        <div className="list_card">
                          <div className="list_date">19 MARCH 2021</div>
                          <div className="list_t1">
                            <strong>
                              Scaling Up Diversity in Startups
                              <br />@ IVCA Conclave 2021
                            </strong>
                          </div>
                          <div className="list_t2">ONLINE</div>
                          <div className="list_t3">
                            <div className="list_t3_box1">
                              <a
                                // target="__blank"
                                href="/ivcaconclave2021/"
                              >
                                Event Report
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                        {/* <div className="top_e_border"></div> */}
                        <div className="list_card">
                          <div className="list_date">27 FEBRUARY 2021</div>
                          <div className="list_t1">
                            <strong>KPMG Ideation Challenge</strong>
                            <br />
                          </div>
                          <div className="list_t2">ONLINE</div>
                          <div className="list_t3">
                            <div className="list_t3_box2">
                              <a
                                target="__blank"
                                href="https://home.kpmg/in/en/home/careers/graduates/kpmg-ideation-challenge-kic.html"
                              >
                                Event Agenda
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                        <div className="list_card">
                          <div className="list_date">19 FEBRUARY 2021</div>
                          <div className="list_t1">
                            <strong>
                              Women in Investing <br />
                              Oxford Seed Fund
                            </strong>
                          </div>
                          <div className="list_t2">ONLINE</div>
                          <div className="list_t3">
                            <div className="list_t3_box1">
                              <a
                                target="__blank"
                                href="https://eship.ox.ac.uk/event/women-in-investing-with-oxford-seed-fund/"
                              >
                                Event Agenda
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                        {/* <div className="top_e_border"></div> */}
                        <div className="list_card">
                          <div className="list_date">
                            DECEMBER 2020 - FEBRUARY 2021
                          </div>
                          <div className="list_t1">
                            <strong>
                              The Alicorn Leadership Summit
                              <br />
                              Winpe Anniversary Celebrations
                            </strong>
                          </div>
                          <div className="list_t2"></div>
                          <div className="list_t3">
                            <div className="list_t3_box2">
                              <a
                                href="https://winpeleadershipsummit.winpeforum.com/home/"
                                target="_blank"
                              >
                                Visit Website
                              </a>
                            </div>
                          </div>

                          <div className="list_date">18 FEBRUARY 2021</div>
                          <div className="list_t1">
                            <strong>Unlocking the Power of Diversity</strong>
                          </div>
                          <div className="list_t2">ONLINE</div>
                          <div className="list_t3">
                            <div className="list_t3_box1">
                              <a
                                href="https://winpeleadershipsummit.winpeforum.com/past-events/"
                                target="_blank"
                              >
                                View Recording
                              </a>
                            </div>
                          </div>

                          <div className="list_date">21 JANUARY 2021</div>
                          <div className="list_t1">
                            <strong>Upping the Stakes</strong>
                          </div>
                          <div className="list_t2">ONLINE</div>
                          <div className="list_t3">
                            <div className="list_t3_box2">
                              <a
                                href="https://winpeleadershipsummit.winpeforum.com/past-events/"
                                target="_blank"
                              >
                                View Recording
                              </a>
                            </div>
                          </div>

                          <div className="list_date">10 DECEMBER 2020</div>
                          <div className="list_t1">
                            <strong>Scale Of Success</strong>
                          </div>
                          <div className="list_t2">ONLINE</div>
                          <div className="list_t3">
                            <div className="list_t3_box1">
                              <a
                                href="https://winpeleadershipsummit.winpeforum.com/past-events/"
                                target="_blank"
                              >
                                View Recording
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                        <div className="list_card">
                          <div className="list_date">28 JANUARY 2021</div>
                          <div className="list_t1">
                            <strong>Winpe Collegium</strong>
                            <br /> By Invite Only
                          </div>
                          <div className="list_t2">ONLINE</div>
                          <div className="list_t3">
                            <div className="list_t3_box2">
                              <Link to="/fourthcollegium/">Event Report</Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                        <div className="list_card">
                          <div className="list_date">16 JANUARY 2021</div>
                          <div className="list_t1">
                            <strong>
                              Startup India – The Way Ahead <br />
                              Prarambh: Startup India International Summit
                            </strong>
                          </div>
                          <div className="list_t2">ONLINE</div>
                          <div className="list_t3">
                            <div className="list_t3_box1">
                              <a
                                target="__blank"
                                href="https://www.theprarambh.in/agenda.html"
                              >
                                Event Agenda
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                        <div className="list_card">
                          <div className="list_date">28 NOVEMBER 2020</div>
                          <div className="list_t1">
                            <strong>
                            Winpe Ignite <br /> Breaking into Investing
                            </strong>
                          </div>
                          <div className="list_t2">ONLINE</div>
                          <div className="list_t3">
                            <div className="list_t3_box2">
                              <a href="/breakingintoinvesting/">Event Report</a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                        <div className="list_card">
                          <div className="list_date">7 NOVEMBER 2020</div>
                          <div className="list_t1">
                            <strong>
                              Shattering Glass Ceilings
                              <br />
                              Wharton India Economic Forum
                            </strong>
                          </div>
                          <div className="list_t2">ONLINE</div>
                          <div className="list_t3">
                            <div className="list_t3_box1">
                              <a
                                href="https://www.whartonindia.com/"
                                target="__blank"
                              >
                                Event Agenda
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                        <div className="list_card">
                          <div className="list_date">7 NOVEMBER 2020</div>
                          <div className="list_t1">
                            <strong>
                              The Art and Science of Public Speaking <br />
                              Winpe Shine Leadership Development Series
                            </strong>
                          </div>
                          <div className="list_t2">ONLINE</div>
                          <div className="list_t3">
                            <div className="list_t3_box2">
                              <a href="/toastmasters/">Event Report</a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                        <div className="list_card">
                          <div className="list_date">6 OCTOBER 2020</div>
                          <div className="list_t1">
                            <strong>
                              {" "}
                              Winpe ProClub Mentorship Program: Launch
                            </strong>
                          </div>
                          <div className="list_t2">ONLINE</div>
                          <div className="list_t3">
                            <div className="list_t3_box1">
                              <a
                                href="https://proclub.winpeforum.com/home/"
                                target="_blank"
                              >
                                See Details
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                        <div className="list_card">
                          <div className="list_date">30 SEPTEMBER 2020</div>
                          <div className="list_t1">
                            <strong>Winpe Collegium</strong>
                            <br /> By Invite Only
                          </div>
                          <div className="list_t2">ONLINE</div>
                          <div className="list_t3">
                            <div className="list_t3_box2">
                              <Link to="/winpecollegiumSeptember/">
                                Event Report
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                        <div className="list_card">
                          <div className="list_date">5 SEPTEMBER 2020</div>
                          <div className="list_t1">
                            <strong>Winpe Ignite Investors Social</strong>
                            <br />
                          </div>
                          <div className="list_t2">ONLINE</div>
                          <div className="list_t3">
                            <div className="list_t3_box1">
                              <Link to="/wiisocial/">Event Report</Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                        <div className="list_card">
                          <div className="list_date">27 AUGUST 2020</div>
                          <div className="list_t1">
                            <strong>
                              Building Strategic Networks <br />
                              Winpe Shine Leadership Development Series
                            </strong>
                          </div>
                          <div className="list_t2">ONLINE</div>
                          <div className="list_t3">
                            <div className="list_t3_box2">
                              <Link to="/wsldsnetworkingeventreport/">
                                Event Report
                              </Link>
                            </div>
                            <div className="list_t3_box1">
                              <Link to="/wsldsnetworking/">
                                Workshop Agenda
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                        <div className="list_card">
                          <div className="list_date">18 JUNE 2020</div>
                          <div className="list_t1">
                            <strong>Winpe Collegium</strong>
                            <br /> By Invite Only
                          </div>
                          <div className="list_t2">ONLINE</div>
                          <div className="list_t3">
                            <div className="list_t3_box2">
                              <Link to="/winpecollegium/">Event Report</Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                        <div className="list_card">
                          <div className="list_date">26, 27, 28 MAY 2020</div>
                          <div className="list_t1">
                            <strong>
                              Bragging with Grace for Impact <br />
                              Winpe Shine Leadership Development Series
                            </strong>
                          </div>
                          <div className="list_t2">ONLINE</div>
                          <div className="list_t3">
                            <div className="list_t3_box1">
                              <Link to="/wsldseventreport/">Event Report</Link>
                            </div>
                            <div className="list_t3_box2">
                              <Link to="/winpeshineprogram/">
                                Workshop Agenda
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                        <div className="list_card">
                          <div className="list_date">24 APRIL 2020</div>
                          <div className="list_t1">
                            <strong>
                            Winpe & PwC Webcast on Impact of the revised FDI
                              policy
                            </strong>
                          </div>
                          <div className="list_t2">ONLINE</div>
                          <div className="list_t3">
                            <div className="list_t3_box1">
                              <Link to="/pwcwebcast/">Event Report</Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                        <div className="list_card">
                          <div className="list_date">03 APRIL 2020</div>
                          <div className="list_t1">
                            <strong>
                            Winpe x Trilegal Webinar on COVID19: Impact on
                              Deals & Contracts{" "}
                            </strong>
                          </div>
                          <div className="list_t2">ONLINE</div>
                          <div className="list_t3">
                            <div className="list_t3_box2">
                              <Link to="/trilegarWebinar/">Event Report</Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                        <div className="list_card">
                          <div className="list_date">08 MARCH 2020</div>
                          <div className="list_t1">
                            <strong>
                              Celebrating Women in Investing | Video Series for
                              International Women's Day
                            </strong>
                          </div>
                          <div className="list_t2">ONLINE</div>
                          <div className="list_t3">
                            <div className="list_t3_box1">
                              <Link to="/womensdayeventreport/">
                                Event Report
                              </Link>
                            </div>
                            <div className="list_t3_box2">
                              <Link to="/iwdvideoseries/">Video Series</Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                        <div className="list_card">
                          <div className="list_date">28 FEBRUARY 2020</div>
                          <div className="list_t1">
                            <strong>Winpe Ignite Network (WIN) </strong>
                          </div>
                          <div className="list_t2">MUMBAI</div>
                          <div className="list_t3">
                            <div className="list_t3_box1">
                              <Link to="/wineventreport/">Event Report</Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                        <div className="list_card">
                          <div className="list_date">17 FEBRUARY 2020</div>
                          <div className="list_t1">
                            <strong>
                              Celebrating Success - Women in Investing: Winpe @
                              IVCA Conclave 2020
                            </strong>
                          </div>
                          <div className="list_t2">Delhi NCR</div>
                          <div className="list_t3">
                            <div className="list_t3_box2">
                              <a
                                href="https://ivcaconclave.com/agenda/"
                                target="_blank"
                              >
                                Event Agenda
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                        <div className="list_card">
                          <div className="list_date">07 FEBRUARY 2020</div>
                          <div className="list_t1">
                            <strong>Maiden Winpe Collegium</strong>
                          </div>
                          <div className="list_t2">MUMBAI</div>
                          <div className="list_t3">
                            <div className="list_t3_box1">
                              <Link to="/maidenCollegium/">Event Report</Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                        <div className="list_card">
                          <div className="list_date">07 FEBRUARY 2020</div>
                          <div className="list_t1">
                            <strong>Winpe : Launching the Dialogue</strong>
                          </div>
                          <div className="list_t2">MUMBAI</div>
                          <div className="list_t3">
                            <div className="list_t3_box2">
                              <Link to="/launchreport/">Event Report</Link>
                            </div>
                            <div className="list_t3_box1">
                              <Link to="/launchagenda/">Event Agenda</Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="gellery_section">
                <div className="gellery_content">
                  <div className="gellery_heading">
                    <div className="">
                      <Heading title="Gallery" />
                    </div>
                  </div>
                  <div className="gellery_list">
                    <Tabs>
                      <TabList>
                        {this.TabContent.map((item, l) => {
                          return <Tab>{item.tabName}</Tab>;
                        })}
                      </TabList>
                      <TabPanel>
                        <div>
                          <Slider {...settings}>
                            {allImages.map((item, j) => {
                              return (
                                <div className="gellery_card" key={j}>
                                  <img src={item.imgUrl} alt={item.title} />
                                </div>
                              );
                            })}
                          </Slider>
                        </div>
                      </TabPanel>
                      <TabPanel>
                        <div>
                          <Slider {...settings}>
                            {winpeEventImages.map((item, k) => {
                              return (
                                <div className="gellery_card" key={k}>
                                  <img src={item.imgUrl} alt={item.title} />
                                </div>
                              );
                            })}
                          </Slider>
                        </div>
                      </TabPanel>
                      <TabPanel>
                        <div>
                          <Slider {...settings}>
                            {winImages1.map((item, p) => {
                              return (
                                <div className="gellery_card" key={p}>
                                  <img src={item.imgUrl} alt={item.title} />
                                </div>
                              );
                            })}
                          </Slider>
                        </div>
                      </TabPanel>

                      <TabPanel>
                        <MediaQuery query="(min-width: 768px)">
                          <div>
                            <div className="row">
                              {winImages2.map((item, q) => {
                                return (
                                  <div className="col-lg-4 col-md-6">
                                    <div className="gellery_carddd" key={q}>
                                      <img src={item.imgUrl} alt={item.title} />
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        </MediaQuery>
                        <MediaQuery query="(max-width: 767px)">
                          <div>
                            <Slider {...settingsingRes}>
                              {winImages2.map((item, q) => {
                                return (
                                  <div className="gellery_cardd" key={q}>
                                    <img src={item.imgUrl} alt={item.title} />
                                  </div>
                                );
                              })}
                            </Slider>
                          </div>
                        </MediaQuery>
                      </TabPanel>
                      <TabPanel>
                        <div>
                          <Slider {...settings}>
                            {winImages3.map((item, w) => {
                              return (
                                <div className="gellery_card" key={w}>
                                  <img src={item.imgUrl} alt={item.title} />
                                </div>
                              );
                            })}
                          </Slider>
                        </div>
                      </TabPanel>
                      <TabPanel>
                        <div>
                          <MediaQuery query="(min-width: 768px)">
                            <div>
                              <div className="row">
                                {breakingintoinvestingImages.map((item, q) => {
                                  return (
                                    <div className="col-lg-4 col-md-6">
                                      <div className="gellery_carddd" key={q}>
                                        <img
                                          src={item.imgUrl}
                                          alt={item.title}
                                        />
                                      </div>
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          </MediaQuery>
                          <MediaQuery query="(max-width: 767px)">
                            <div>
                              <Slider {...settingsingRes}>
                                {breakingintoinvestingImages.map((item, q) => {
                                  return (
                                    <div className="gellery_cardd" key={q}>
                                      <img src={item.imgUrl} alt={item.title} />
                                    </div>
                                  );
                                })}
                              </Slider>
                            </div>
                          </MediaQuery>
                        </div>
                      </TabPanel>
                      <TabPanel>
                        <div>
                          <Slider {...settings}>
                            {igniteAMAImages.map((item, w) => {
                              return (
                                <div className="gellery_card" key={w}>
                                  <img src={item.imgUrl} alt={item.title} />
                                </div>
                              );
                            })}
                          </Slider>
                        </div>
                      </TabPanel>
                    </Tabs>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ContentPage>
    );
  }
}

ConnectView.propTypes = {
  location: PropTypes.object,
};

export default ConnectView;



// WEBPACK FOOTER //
// ./src/pages/events/index.js